import { render } from "./CodeAuthorityTerms.vue?vue&type=template&id=bf6942cc"
import script from "./CodeAuthorityTerms.vue?vue&type=script&lang=js"
export * from "./CodeAuthorityTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__